import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="exercise-session-nested-form"
export default class extends Controller {
  static targets = [ 'template', 'item' ]
  static values = {
    wrapperSelector: String
  }

  add(event) {
    const content = event.target.closest('button').parentElement.querySelector(event.params.template).innerHTML;

    event.target.closest('button').insertAdjacentHTML('beforebegin', content)
  }

  remove(event) {
    const item = event.target.closest("[data-exercise-session-nested-form-target='item']").parentElement;
    const destroyField = item.querySelector("input[name*='_destroy']");
    if (destroyField) {
      destroyField.value = 1;
      item.style.display = 'none';
    } else {
      item.remove();
    }
  }

  submit(event) {
    const form = event.target;

    for (const [exerciseIndex, exercise] of form.querySelectorAll('.exercise').entries()) {
      for (const [exerciseSetIndex, exerciseSet] of exercise.querySelectorAll('.exercise-set').entries()) {
        for (const [exerciseBandIndex, exerciseBand] of exerciseSet.querySelectorAll('.exercise-band').entries()) {
          this.replacePlaceholders(exerciseBand, exerciseIndex, exerciseSetIndex, exerciseBandIndex);
        }
        this.replacePlaceholders(exerciseSet, exerciseIndex, exerciseSetIndex);
      }
      this.replacePlaceholders(exercise, exerciseIndex);
    }
  }

  replacePlaceholders(element, exercise_id, set_id = null, band_id = null) {
    for (const child of element.children) {
      if (child.children.length > 0) {
        this.replacePlaceholders(child, exercise_id, set_id, band_id);
      }

      child.id = child.id.replace(/EXERCISE_NEW_RECORD/g, exercise_id);
      if (child.name !== undefined) child.name = child.name.replace(/EXERCISE_NEW_RECORD/g, exercise_id);

      if (set_id !== null) {
        child.id = child.id.replace(/EXERCISE_SET_NEW_RECORD/g, set_id);
        if (child.name !== undefined) child.name = child.name.replace(/EXERCISE_SET_NEW_RECORD/g, set_id);
      }

      if (band_id !== null) {
        child.id = child.id.replace(/EXERCISE_BAND_NEW_RECORD/g, band_id);
        if (child.name !== undefined) child.name = child.name.replace(/EXERCISE_BAND_NEW_RECORD/g, band_id);
      }
    }
  }
}
